import styled from 'styled-components';
// eslint-disable-next-line
import React from 'react';
import { Paper, Box, Link, Theme } from '@material-ui/core';

type Props = { $type?: string; $theme: Theme };

const AlertIcon = styled(({ component, ...props }) =>
  React.cloneElement(component, props)
)`
  ${({ $theme }) => `
  margin: ${$theme.spacing(0.25, 0.75)};
  `}
`;

const AlertPaper = styled(Paper)<Props>`
  ${({ $theme: { typography, spacing } }) => `
    display: flex;
    align-items: center;
    padding: ${spacing(0.5, 1.25, 0.5, 0.75)};
    font-size: ${typography.body2.fontSize};
  `}

  /*SUCCESS*/
  ${({ $type, $theme: { palette } }) =>
    $type === 'success' &&
    `background-color: ${palette.success.light};    
      
      > ${AlertIcon} {
        color: ${palette.success.main}
      }
  `}

  /*ERROR*/
  ${({ $type, $theme: { palette } }) =>
    $type === 'error' &&
    `background-color: ${palette.error.light}; 

      > ${AlertIcon} {
        color: ${palette.error.main}
      }
  `}

  /*INFO*/
  ${({ $type, $theme: { palette } }) =>
    $type === 'info' &&
    `background-color: ${palette.info.light};

      > ${AlertIcon} {
        color: ${palette.info.dark}
      }
  `}

  /*WARNING*/
  ${({ $type, $theme: { palette } }) =>
    $type === 'warning' &&
    `background-color: ${palette.warning.light};

      > ${AlertIcon} {
        color: ${palette.warning.dark}
      }
  `}
`;

const AlertBox = styled(Box)`
  align-self: center;
`;

const AlertLink = styled(Link)<Props>`
  ${({ $theme }) => `
  cursor: pointer;
  text-decoration: underline;
  margin-left: ${$theme.spacing(0.5)}px;
  color: ${$theme.palette.error.main}
  `}
`;

export { AlertIcon, AlertPaper, AlertBox, AlertLink };
